import Jsona, { SwitchCaseJsonMapper } from 'jsona'
import { irwin } from 'config'
import { httpClient } from './httpClient'

const DEFAULT_IRM_AFFILIATIONS_URL = 'v2/irm_affiliations'

const deserializer = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

function client() {
  return httpClient(irwin.baseUrl)
}

export async function getIrmAffiliations(params = {}) {
  const response = await client().get(DEFAULT_IRM_AFFILIATIONS_URL, { params: params })

  return {
    data: deserializer.deserialize(response),
    total: response.meta?.total || 0,
  }
}

export function getIrmAffiliationsCSVUrl(affiliatedId) {
  return `${irwin.baseUrl}/${DEFAULT_IRM_AFFILIATIONS_URL}.csv?affiliated_id=${affiliatedId}`
}
